import { render, staticRenderFns } from "./viewer2.vue?vue&type=template&id=77991045&scoped=true"
import script from "./viewer2.vue?vue&type=script&lang=js"
export * from "./viewer2.vue?vue&type=script&lang=js"
import style0 from "./viewer2.vue?vue&type=style&index=0&id=77991045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77991045",
  null
  
)

export default component.exports